module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zltvZQ/tc-custom/9781452158303.jpg?1695809665818",
      "alt": "This image is the cover for the book Muffins and Biscuits"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Muffins and Biscuits\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fresh twists on classic morning treats from the author of "), _c('i', [_vm._v("Grilled Cheese Kitchen")]), _vm._v("!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Whether slathered with mouthwatering homemade spreads or savored just as they are, muffins and biscuits are comfort food at its finest. This cookbook features fifty recipes for tender-on-the-inside, crunchy-on-the-outside biscuits and melt-in-your-mouth muffins, plus an irresistible assortment of flavored butters, sauces, and preserves."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With sweet and savory varieties and exciting new flavor combinations—think Quinoa Muffins with Cheddar, Apples, and Rosemary or Orange Zest, Ham, and Thyme Biscuits—it lets bakers of all skill levels delight in fresh twists on classic treats. Packed with tips and tricks, from making delectable pancakes with muffin batter to turning leftover biscuits into bread pudding, it takes time-tested breakfast favorites to an entirely new level of deliciousness. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Heidi Gibson, Antonis Achilleos\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0